/**
 * Whether a voice sounds like a man or a woman.
 *
 * It matters only in Hebrew, where the assistant cannot say "I hear you" without
 * choosing: שומע or שומעת. An answer in a woman's voice saying שומע — or the two
 * forms alternating from one answer to the next — sounds wrong every time. So the
 * model is told which voice is speaking, and keeps to it.
 *
 * OpenAI's built-in voices, and Speechify's family default. Anything else is left
 * unknown, and the prompt treats unknown as a woman's voice (the default voice is
 * one).
 */
const GENDERS: Record<string, 'female' | 'male'> = {
  alloy: 'female',
  ash: 'male',
  ballad: 'male',
  cedar: 'male',
  coral: 'female',
  echo: 'male',
  fable: 'male',
  marin: 'female',
  nova: 'female',
  onyx: 'male',
  sage: 'female',
  shimmer: 'female',
  verse: 'male',
  george: 'male',
};

export function voiceGender(voice: string): 'female' | 'male' | undefined {
  return GENDERS[voice.trim().toLowerCase()];
}
